import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { GOTO_TARGETS } from '@/hooks/useShortcuts'

function Keys({ keys }: { keys: string[] }) {
  return (
    <span className="flex shrink-0 items-center gap-1">
      {keys.map((key) => (
        <kbd
          key={key}
          className="bg-muted text-muted-foreground border-border rounded border px-1.5 py-0.5 font-mono text-[11px] leading-none"
        >
          {key}
        </kbd>
      ))}
    </span>
  )
}

function Row({ keys, children }: { keys: string[]; children: string }) {
  return (
    <div className="flex items-baseline justify-between gap-4 py-1.5">
      <span className="text-sm">{children}</span>
      <Keys keys={keys} />
    </div>
  )
}

export interface ShortcutHelpProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

/** The `?` overlay: what exists, and where it deliberately does not apply. */
export function ShortcutHelp({ open, onOpenChange }: ShortcutHelpProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[85vh] overflow-y-auto sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Tastaturkürzel</DialogTitle>
          <DialogDescription>
            Buchstaben-Kürzel greifen nicht, während du in einem Feld schreibst.
          </DialogDescription>
        </DialogHeader>

        <div className="divide-border divide-y">
          <div className="pb-2">
            <Row keys={['Strg', 'K']}>Befehle durchsuchen</Row>
            <Row keys={['Strg', '⇧', 'P']}>Befehle durchsuchen (auch im Terminal)</Row>
            <Row keys={['Strg', '⇧', 'L']}>Vault sperren</Row>
            <Row keys={['?']}>Diese Übersicht</Row>
          </div>

          <div className="py-2">
            <p className="text-muted-foreground pb-1 text-xs">
              Springen: erst <span className="font-mono">g</span>, dann
            </p>
            {GOTO_TARGETS.map((target) => (
              <Row key={target.key} keys={['g', target.key]}>
                {target.label}
              </Row>
            ))}
          </div>
        </div>

        <p className="text-muted-foreground text-xs">
          Im Terminal geht jede Taste an die entfernte Shell — auch Strg+K und Strg+L, die dort
          eigene Bedeutungen haben. Nur Strg+Umschalt+P und Strg+Umschalt+L fängt Kontor ab.
        </p>
      </DialogContent>
    </Dialog>
  )
}
